<template>
    <div class="row align-items-center">
        <div class="col-12">
            <div class="creditscore-block">
                <p class="creditscore-heading">
                    {{ offer.other_information.title }}
                </p>

                <p>
                    {{ offer.other_information.synopsis }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['offer'],
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.creditscore-block {
    background-color: #f4f5f6;
    border-radius: 8px;
    padding: 17px;

    p {
        font-size: rem(14px);
        color: #808080;
        margin: 0;
    }

    .creditscore-heading {
        font-weight: 600;
        color: black;
        margin-bottom: 10px;
    }
}
</style>
